import { render, staticRenderFns } from "./Tgsq.vue?vue&type=template&id=60b46c44"
import script from "./Tgsq.vue?vue&type=script&lang=js"
export * from "./Tgsq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports